import React from 'react';

const AffStatBarNew = ({ stats, filteredEvents, handleStatusListClick }) => {
  const calculatePercent = (val) => {
    if (!stats.totalHosts || stats.totalHosts === 0) return "0.00";
    return ((val * 100) / stats.totalHosts).toFixed(2);
  };

  const WarningIcon = ({ color = "#64748b" }) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  );

  const ToolsIcon = ({ color = "#64748b" }) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
  );

  const StatCard = ({ label, value, color, bgColor, exc, mtto, statusKey, last = false }) => (
    <div 
      onClick={() => handleStatusListClick(statusKey)}
      style={{
        display: 'flex', flexDirection: 'column', gap: 2,
        padding: '5px 14px',
        borderRight: last ? 'none' : '1px solid #e2e8f0',
        minWidth: 0,
        cursor: 'pointer',
        transition: 'background 0.2s'
      }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.02)'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
    >
      <div style={{ display:'flex', alignItems:'center', gap:5, marginBottom:2 }}>
        <div style={{
          width:8, height:8, borderRadius:'50%',
          background: color,
          flexShrink:0
        }}/>
        <span style={{ fontSize:10, fontWeight:600, color: color }}>
          {label}
        </span>
      </div>
      <div style={{ display:'flex', alignItems:'baseline', gap:5 }}>
        <div style={{
          fontSize:24, fontWeight:700, lineHeight:1,
          fontFamily:'monospace',
          color: color
        }}>
          {value}
        </div>
        <div style={{
          fontSize:10, fontWeight:600,
          padding:'1px 5px', borderRadius:4,
          background: bgColor,
          color: color
        }}>
          {calculatePercent(value)}%
        </div>
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:2 }}>
        <span style={{ display:'flex', alignItems:'center', gap:3, fontSize:9, color:'#64748b' }}>
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M6 1l1.5 3h3l-2.5 2 1 3L6 7.5 3 9l1-3L1.5 4h3z" stroke="#64748b" strokeWidth="1" fill="none"/></svg>
          {exc} exc
        </span>
        <span style={{ display:'flex', alignItems:'center', gap:3, fontSize:9, color:'#64748b' }}>
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="4" stroke="#64748b" strokeWidth="1.2"/><path d="M4 6l1.5 1.5L8 4" stroke="#64748b" strokeWidth="1.2" strokeLinecap="round"/></svg>
          {mtto} mtto
        </span>
      </div>
    </div>
  );

  return (
    <div style={{
      background: 'rgba(255,255,255,0.97)',
      borderBottom: '1px solid #e2e8f0',
      padding: '7px 14px',
      display: 'flex',
      alignItems: 'stretch',
      gap: 0,
      flexWrap: 'wrap',
      width: '100%'
    }}>
      {/* TOTAL */}
      <div 
        onClick={() => handleStatusListClick('total')}
        style={{
          display: 'flex', flexDirection: 'column', gap: 2,
          padding: '5px 14px 5px 0',
          borderRight: '1px solid #e2e8f0',
          marginRight: 6, minWidth: 110,
          cursor: 'pointer'
        }}
      >
        <div style={{ fontSize:11, fontWeight:500, color:'#334155' }}>Total Dispositivos</div>
        <div style={{ fontSize:26, fontWeight:700, color:'#0f172a', lineHeight:1.2, fontFamily:'monospace' }}>
          {stats.totalHosts}
        </div>
        <div style={{ fontSize:9, color:'#64748b' }}>afiliaciones: {filteredEvents.length}</div>
      </div>

      {/* CONECTADOS */}
      <StatCard label="Conectados" value={stats.ok} color="#057a55" bgColor="#d1fae5" exc={stats.ok_exceptions} mtto={stats.ok_maintenance} statusKey="ok" />

      {/* DESCONECTADOS */}
      <StatCard label="Desconectados" value={stats.down} color="#db2777" bgColor="#fce7f3" exc={stats.down_exceptions} mtto={stats.down_maintenance} statusKey="offline" />

      {/* DESCONOCIDOS */}
      <StatCard label="Desconocidos" value={stats.unknown} color="#94a3b8" bgColor="#f1f5f9" exc={stats.unknown_exceptions} mtto={stats.unknown_maintenance} statusKey="unknown" />

      {/* GESTION GLOBAL GROUP */}
      <div style={{ display: 'flex', alignItems: 'stretch', marginLeft: 'auto', border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '0 12px', background: '#f8fafc',
          fontSize: 11, color: '#64748b', fontWeight: 500,
          borderRight: '1px solid #e2e8f0'
        }}>
          Gestion Global
        </div>

        {/* EXCEP */}
        <div 
          onClick={() => handleStatusListClick('except')}
          style={{
            display: 'flex', flexDirection: 'column', gap: 2,
            padding: '5px 14px', borderRight: '1px solid #e2e8f0',
            minWidth: 85, cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(126, 58, 242, 0.04)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <div style={{ display:'flex', alignItems:'center', gap:5, marginBottom:2 }}>
            <WarningIcon color="#7e3af2" />
            <span style={{ fontSize:10, fontWeight:700, color: '#7e3af2', textTransform: 'uppercase' }}>EXCEP</span>
          </div>
          <div style={{ display:'flex', alignItems:'baseline', gap:5 }}>
            <div style={{ fontSize:22, fontWeight:700, lineHeight:1, fontFamily:'monospace', color: '#7e3af2' }}>
              {stats.total_exceptions}
            </div>
            <div style={{ fontSize:9, fontWeight:600, padding:'1px 4px', borderRadius:4, background: '#f5f3ff', color: '#7e3af2' }}>
              {calculatePercent(stats.total_exceptions)}%
            </div>
          </div>
        </div>

        {/* MTTO */}
        <div 
          onClick={() => handleStatusListClick('mtto')}
          style={{
            display: 'flex', flexDirection: 'column', gap: 2,
            padding: '5px 14px', minWidth: 85,
            cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(217, 119, 6, 0.04)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <div style={{ display:'flex', alignItems:'center', gap:5, marginBottom:2 }}>
            <ToolsIcon color="#d97706" />
            <span style={{ fontSize:10, fontWeight:700, color: '#d97706', textTransform: 'uppercase' }}>MTTO</span>
          </div>
          <div style={{ display:'flex', alignItems:'baseline', gap:5 }}>
            <div style={{ fontSize:22, fontWeight:700, lineHeight:1, fontFamily:'monospace', color: '#d97706' }}>
              {stats.total_maintenance}
            </div>
            <div style={{ fontSize:9, fontWeight:600, padding:'1px 4px', borderRadius:4, background: '#fef3c7', color: '#d97706' }}>
              {calculatePercent(stats.total_maintenance)}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffStatBarNew;
